import useFetch from '@hooks/useFetch';

const useChildNoteInfo = (noteId, { revalidateOnMount = false }) => {
  const key = `v1/topology/child/note/?note_id=${noteId}`;
  const { data, ...rest } = useFetch(
    noteId ? key : null,
    {},
    {
      revalidateOnMount
    }
  );

  return { childNoteInfo: data ?? {}, ...rest };
};

export default useChildNoteInfo;
